import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import i18n from 'live/services/i18n'
import LoadingBar from './LoadingBar'

export default function Importing({ importingMessage = null }) {    
    const { Type = 'Loading...', messages = [] } = parseMsg(importingMessage) || {}
    const { status = 'waiting response' } = messages[0] || {}
    
    return (
        <Modal.Dialog dialogClassName="modal-loading">
            <Modal.Body style={{ backgroundColor: '#FFFFFF' }}>
                <LoadingBar percent={getPct(status)} title={Type} status={status} />
            </Modal.Body>
        </Modal.Dialog>
    )
}

function parseMsg(obj){
    try{        
        return JSON.parse(obj)
    }catch(e){        
        return {}
    }
}
function getPct(status:string):number{
    
    try{
        const match = status.match(/[0-9]+\s[o][f]\s[0-9]+/g)
        const msg = match[0]        
        const [row,total] = msg.split(' of ')
        const pct = (parseInt(row)/parseInt(total))  * 100        
        if(!!pct && pct > 0){
            return pct
        }
        return 0
    }catch(_){
        return 0
    }

}